export class SubmissionError extends Error {
  constructor(errors) {
    super('Submit Validation Failed');
    this.name = 'SubmissionError';
    this.errors = errors;
  }
}
